import React, {useRef, useLayoutEffect} from 'react';
import Img1 from '../../images/history_photo_01.jpg';
import Img2 from '../../images/history_photo_02.jpg';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';

import {
    HistoryWrapper,
    SchaduleContent,
    TitleHistory,
    HistoryImgOne,
    HistoryImgTwo,
    Wrapper1,
    TitleSeparador,
    ParagOne,
    ParagTwo,
    ParagThree,
    Wrapper2,
} from './HistoryElements';


const HistorySection = () => {
    const ref = useRef(null);
    const { t } = useTranslation();

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".schadule", {
            y: 0,
            opacity: 1,
            scrollTrigger:{
                trigger: "#historia",
                start: "top 500px",
                end: "top 50px",
                scrub: true,
                // markers: true,
            }
        })
        return() => {
            gsap.killTweensOf(".schadule");
        }
    }, [])




  return (
    <>
        <HistoryWrapper ref={ref} id='historia'>
        <SchaduleContent className='schadule'>
            <TitleHistory className='title'>{t('historia.titulo')}</TitleHistory>
            <TitleSeparador>.</TitleSeparador>
            <Wrapper1>
                <HistoryImgOne loading="lazy" src={Img1} alt='imagem ambiente do restaurante'/>
                <ParagOne>{t('historia.ParagOne')}</ParagOne>
            </Wrapper1>
            
            <ParagTwo>{t('historia.ParagTwo')}</ParagTwo>
            <Wrapper2>
                <ParagThree>{t('historia.ParagThree')}</ParagThree>
                <HistoryImgTwo loading="lazy" src={Img2} alt='imagem ambiente do restaurante'/>
            </Wrapper2>
        </SchaduleContent>
        </HistoryWrapper>
      
    </>
  )
}


export default HistorySection

